import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ClientTableHeader = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold text-white">Recent Clients</h2>
      <Button
        onClick={() => navigate('/admin/clients/new')}
        className="flex items-center gap-2"
      >
        <Plus className="h-4 w-4" />
        Add Client
      </Button>
    </div>
  );
};